/**
 * Publications Block Component
 * Displays a grid of publications on the home page
 * Uses @uicwebmaster/publications package directly
 */

'use client';

import type { Publication } from '@uicwebmaster/publications';
import { PublicationCard } from '@uicwebmaster/publications';
import { BlockLayout } from './BlockLayout';

interface PublicationsProps {
  /** Publications data from @uicwebmaster/publications */
  publications: Publication[];
}

export default function Publications({ publications }: PublicationsProps) {
  return (
    <BlockLayout
      title="Publications"
      seeAllUrl="/publications"
      data={publications}
      renderItem={publication => (
        <PublicationCard publication={publication} />
      )}
      loading={false}
      error={null}
    />
  );
}
